module.exports = __webpack_public_path__ + "static/img/user_avatar07.57f71d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar07.png
// module id = HzkC
// module chunks = 1